export default __webpack_public_path__ + "static/media/phone_icon.170cdf6c.svg";